export default "__VITE_ASSET__v6fzAKPJ__"